import Layout from '@/layout'

const FBARouter = {
  path: '/FBA',
  component: Layout,
  redirect: 'noredirect',
  name: 'FBA',
  meta: {
    title: 'FBA',
    icon: 'daohang-ziliaoguanli',
    roles: []
  },
  children: [
    {
      path: 'FBAOrder',
      component: () => import('@/views/cargo/v0/FBA/fbaOrder'),
      name: 'FBAOrder',
      meta: { title: 'FBA下单' },
      roles: ['module_FBAOrder']
    },
    {
      path: 'FBAVerify',
      component: () => import('@/views/cargo/v0/FBA/fbaVerify'),
      name: 'FBAVerify',
      meta: { title: '订单审核' },
      roles: ['module_FBAVerify']
    },
    {
      path: 'FBABookingNew',
      component: () => import('@/views/cargo/v0/FBA/fbaBookingNew'),
      name: 'FBABookingNew',
      meta: { title: '海运头程' },
      roles: ['module_FBABookingNew']
    },
    {
      path: 'FBAAeBooking',
      component: () => import('@/views/cargo/v0/FBA/fbaAeBooking'),
      name: 'FBAAeBooking',
      meta: { title: '空运头程' },
      roles: ['module_FBAAeBooking']
    },
    {
      path: 'FBARailwayExport',
      component: () => import('@/views/cargo/v0/FBA/fbaRailwayExport'),
      name: 'FBARailwayExport',
      meta: { title: '铁路头程' },
      roles: ['module_FBARailwayExport']
    },
    {
      path: 'FBAWarehousing',
      component: () => import('@/views/cargo/v0/FBA/Warehousing/index'),
      name: 'FBAWarehousing',
      meta: { title: '国内仓' },
      roles: ['module_FBAWarehousing']
    },
    {
      path: 'FBAOverseaWarehousing',
      component: () => import('@/views/cargo/v0/FBA/OverseaWarehousing/index'),
      name: 'FBAOverseaWarehousing',
      meta: { title: '国外仓' },
      roles: ['module_FBAOverseaWarehousing']
    },
    {
      path: 'FBAMailingAddress',
      component: () => import('@/views/cargo/v0/FBA/fbaMailingAddress'),
      name: 'FBAMailingAddress',
      meta: { title: '收发通地址(FBA)' },
      roles: ['module_FBAMailingAddress']
    }
  ]
}

export default FBARouter
